export default __webpack_public_path__ + "static/media/logo.ea285ee7.webp";